import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

const relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)

const dateFormat = 'YYYY-MM-DD HH:mm';

export const columns = [
  {
    key: 'stateId',
    dataIndex: 'stateId',
    render: stateId => <FormattedMessage id={stateId} />,
  },
  {
    key: 'started',
    dataIndex: 'started',
    render: started => dayjs(started).format(dateFormat),
  },
  {
    key: 'startedRelative',
    dataIndex: 'started',
    render: started => dayjs(started).fromNow(),
  },
]
